module.exports = __webpack_public_path__ + "media/images/icon_mypage_arrow_down-f3a4c3fac44920ecc6f429a2e0a70ca6.png";